/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.gen.ai.skills.rpc.AiFeedbackRpc
 */
import * as References from './AiFeedbackRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.gen.ai.skills.rpc.AiFeedbackRpc#sendAiFeedback
 */
export const SEND_AI_FEEDBACK_MUTATION_FIELD_NAME = 'com_hubspot_academy_gen_ai_skills_rpc_AiFeedbackRpc_sendAiFeedback';
export const SEND_AI_FEEDBACK_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: SEND_AI_FEEDBACK_MUTATION_FIELD_NAME,
  args: ['correlationId', 'ratingScore', 'feedbackText', 'feedbackTags', 'featureId'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.sendAiFeedbackRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});